module.exports = __webpack_public_path__ + "img/6812ce316ace016bca86811ad1774f61.png";